import React from 'react'

import cn from 'classnames'

import styles from './LogOut.module.scss'
import { Typography } from '../typography/typography'

interface LogOutProps {
  logout: () => void
  children: React.ReactNode
  className?: string
}

export const LogOut = ({ logout, children, className }: LogOutProps) => (
  <a
    href={'/login'}
    tabIndex={0}
    onKeyDown={(event) => {
      if (event.key === 'Enter') {
        event.preventDefault()
        logout()
      }
      return null
    }}
    onClick={(event) => {
      event.preventDefault()
      logout()
    }}
    className={cn([className, styles.logoutText])}
    data-testid="logout-menu"
  >
    <Typography variant="Kollektif/MediumEmphasis" component="span">
      {children}
    </Typography>
  </a>
)

export default LogOut
